import MegaOption from "../../../../../Components/CardsPages/Forms/MegaOption";
import MegaOptionGroup from "../../../../../Components/CardsPages/Forms/MegaOptionGroup";
import { Dispatch, SetStateAction, useState } from "react";
import { VistoriaExecutadaSolicitacaoProcedenteController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { TiposVistoria } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/VistoriaProcedente/VistoriaProcedenteInterface";
import UnForm from "../../../../../Components/Form";
import { useHistoricoContext } from "../../../../../Context/Historico";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { ListarCategoriaAtendimentosController } from "../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CriarAgendamento from "../../../../../Components/CardsPages/Atendimento/CriarAgendamento";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import { IAtendimento } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";
interface ISolicitacaoProcedenteProps {
    ID_CATEGORIA: number;
    setShow: Dispatch<SetStateAction<boolean>>;
    Atendimento: IAtendimento;
}

interface ISolicitacaoProcedenteFormData {
    ID_CATEGORIA: number;
    DS_HISTORICO: string;
}

export default function VistoriaRealizadaSolicitacaoProcedente(
    props: ISolicitacaoProcedenteProps
) {
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const [check, setCheck] = useState<TiposVistoria>();
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { execute: executarVistoriaExecutada, loading } = useAsyncCallback(
        VistoriaExecutadaSolicitacaoProcedenteController
    );

    const { value: listarCategorias, loading: listarCategoriasLoading } =
        useAsyncEffect(() => ListarCategoriaAtendimentosController());

    function handleVerificarForm(formData: ISolicitacaoProcedenteFormData) {
        AlertConfirmation(
            `Categoria de Atendimento Atual: ${Atendimento?.DS_CATEGORIA_ATENDIMENTO}, prosseguir?`,
            "",
            undefined,
            { cancelButtonText: "Não", confirmButtonText: "Sim" }
        ).then((response) => {
            if (response.isConfirmed && check) {
                executarVistoriaExecutada(ID_CASO, check, { ...formData }).then(
                    () => {
                        updateAtendimento();
                        ReloadHistorico();
                        props.setShow(false);
                    }
                );
            }
        });
    }

    const dsCategoriaComp = listarCategorias?.find(
        (categoria) => categoria.ID_CATEGORIA_ATENDIMENTO === props.ID_CATEGORIA
    )?.DS_CATEGORIA_ATENDIMENTO_COMP;

    return (
        <OrSpinner loading={listarCategoriasLoading} spinner="capys">
            <div>
                {
                    <UnForm handleSubmit={handleVerificarForm}>
                        <div className="input-group mb-5 d-flex flex-column">
                            <label>
                                <strong>Categoria Atual:</strong>{" "}
                                {dsCategoriaComp}
                            </label>
                            <UnForm.SelectCategoriaAtendimento
                                name="ID_CATEGORIA"
                                defaultValue={props.ID_CATEGORIA}
                                registerOptions={{
                                    required: "Insira a Categoria",
                                }}
                            />
                        </div>
                        <div className="col-12 mb-4 p-0">
                            <MegaOptionGroup
                                name="link"
                                checked={check}
                                onChange={(value) => {
                                    setCheck(value as TiposVistoria);
                                }}
                            >
                                <MegaOption
                                    title="Concluir Atendimento"
                                    description="Selecionar essa opção caso você já tenha resolvido o problema relatado pelo cliente."
                                    value={"VistoriaEmanutencao"}
                                />
                                <MegaOption
                                    title="Marcar Reparo"
                                    description="Selecionar essa opção caso você já tenha definido junto com o cliente o dia e a hora do seu retorno para execução do serviço."
                                    value={"Agendar"}
                                />
                                {check === "Agendar" && (
                                    <div
                                        className="d-flex justify-content-center align-items-center flex-column"
                                        title="Agenda"
                                    >
                                        <button
                                            className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap ml-3 mr-3 g-2 m-3"
                                            onClick={() => {
                                                setShow(true);
                                                setModal({
                                                    headerComponent:
                                                        "Criar Agendamento",
                                                    IconHeader: faPlus,
                                                    Component: () => (
                                                        <CriarAgendamento
                                                            updateList={() =>
                                                                updateAtendimento()
                                                            }
                                                            setShow={setShow}
                                                            Atendimento={
                                                                props.Atendimento
                                                            }
                                                        />
                                                    ),
                                                    size: "lg",
                                                });
                                            }}
                                        >
                                            Novo Agendamento
                                            <span>
                                                <FontAwesomeIcon
                                                    icon={faPlus}
                                                />
                                            </span>
                                        </button>
                                    </div>
                                )}

                                <MegaOption
                                    title="Solicitar Agendamento"
                                    description="Selecionar essa opção caso você NÃO tenha definido junto com o cliente o dia e a hora do seu retorno para execução do serviço. Nesse caso um responsável na construtora irá realizar o agendamento e informá-los sobre o harário da visita."
                                    value={"AgendarPosteriormente"}
                                />
                            </MegaOptionGroup>
                        </div>

                        <div className="col-12 mb-4 p-0">
                            <UnForm.Textarea
                                registerOptions={{
                                    required: "Insira o Descrição",
                                }}
                                name="DS_HISTORICO"
                                placeholder="Descrição ( Obrigatório )"
                            />
                        </div>

                        <button
                            className="btn btn-success col-12 d-flex g-2 align-items-center justify-content-center"
                            type="submit"
                            disabled={loading}
                        >
                            Continuar
                            {loading && <Spinner size="sm" />}
                        </button>
                    </UnForm>
                }
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </OrSpinner>
    );
}
